module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.20fd170.woff2";